import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from '../../../services/utils/images.service';
import { ServicioAdmisionesService, AdmisionAbiertaEntity, ReportAdmisionesAbiertasEntity, AgrupacionSedeAdmisionAbiertaEntity } from '../../../services/servicio-admisiones.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServicioEntidadService, EntidadEmpresarialEntity } from '../../../services/servicio-entidad.service';
import { ServicioLoginService, LoginEntity } from '../../../services/servicio-login.service';

@Component({
  selector: 'app-reporte-admisiones-abiertas',
  templateUrl: './reporte-admisiones-abiertas.component.html',
  styleUrls: ['./reporte-admisiones-abiertas.component.css']
})
export class ReporteAdmisionesAbiertasComponent implements OnInit {

  logo: string;
  mensajeLoading: string;
  mensajeError: string;

  totalAdmisiones: number;

  fechaImpresion: Date;

  agrupacion: AgrupacionSedeAdmisionAbiertaEntity[];
  entidad: EntidadEmpresarialEntity;
  usuario: LoginEntity;

  filtrosSeleccionados: ReportAdmisionesAbiertasEntity;

  objectAdmisionAbierta: ReportAdmisionesAbiertasEntity = {};

  constructor(private activatedRoute: ActivatedRoute,
              private servicioEntidad: ServicioEntidadService,
              private servicioImagenes: ImagesService,
              private servicioAdmisiones: ServicioAdmisionesService,
              private servicioLogin: ServicioLoginService) {
    this.activatedRoute.params.subscribe(params => {
      this.objectAdmisionAbierta.codigo = params['codigoBaseDatos'];
      this.objectAdmisionAbierta.uncoSede = params['uncoSede'];
      this.objectAdmisionAbierta.uncoLogin = params['uncoLogin'];
    });
  }

  ngOnInit() {
  }

  public onFiltrosCompletados(obj: ReportAdmisionesAbiertasEntity) {
    this.filtrosSeleccionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioImagenes.getLogo(this.filtrosSeleccionados.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        this.logo = null;
        this.getEntidadEmpresarial();
        console.error('Error ReporteAdmisionesAbiertas.getLogo()', err);
      });
    } catch(e) {
      this.logo = null;
      this.getEntidadEmpresarial();
      console.error('Catch ReporteAdmisionesAbiertas.getLogo()', e);
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.filtrosSeleccionados.codigo,
        this.filtrosSeleccionados.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        this.entidad = data[0];
        this.getInformacionUsuario();
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.entidad = null;
        this.mensajeError = 'Error al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error ReporteAdmisionesAbiertas.getEntidadEmpresarial()', err);
      })
    } catch(e) {
      this.mensajeLoading = '';
      this.entidad = null;
      this.mensajeError = 'Error grave al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Catch ReporteAdmisionesAbiertas.getEntidadEmpresarial()', e);
    }
  }

  async getInformacionUsuario() {
    try {
      this.mensajeLoading = 'Cargando información usuario ...';
      const response = await this.servicioLogin.getUsuario(this.filtrosSeleccionados.codigo, this.filtrosSeleccionados.uncoLogin);
      response.subscribe((data: LoginEntity) => {
        this.usuario = data;
        this.getInformacionAdmisiones()
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        this.usuario = null;
        console.error('Error ReporteAdmisionesAbiertas.getInformacionUsuario()', err);
      })
    } catch(e) {
      this.mensajeLoading = '';
      this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.usuario = null;
      console.error('Catch ReporteAdmisionesAbiertas.getInformacionUsuario()', e);
    }
  }

  async getInformacionAdmisiones() {
    try {
      this.mensajeLoading = 'Cargando admisiones ...';
      const response = await this.servicioAdmisiones.getAdmisionesAbiertas(this.filtrosSeleccionados.codigo, this.filtrosSeleccionados.fechaInicial,
        this.filtrosSeleccionados.fechaFinal, this.filtrosSeleccionados.sedes, this.filtrosSeleccionados.usuariosRealiza, this.filtrosSeleccionados.usuariosModifica);
        response.subscribe((data: AdmisionAbiertaEntity[]) => {
          this.agruparPorSede(data);
          this.mensajeLoading = '';
        }, (err: HttpErrorResponse) => {
          this.mensajeLoading = '';
          this.agrupacion = null;
          this.mensajeError = 'Error al obtener información de admisiones, verifique conexión a internet. De lo contrario reporte caso al administrador.';
          console.error('Error ReporteAdmisionesAbiertas.getInformacionAdmisiones()', err);
        });
    } catch(e) {
      this.mensajeLoading = '';
      this.agrupacion = null;
      this.mensajeError = 'Error al obtener información de admisiones, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Error ReporteAdmisionesAbiertas.getInformacionAdmisiones()', e);
    }
  }

  // Auxiliares
  isAvailableHeader() {
    return !this.mensajeLoading && !this.mensajeError && this.entidad && this.entidad.unco > 0 && this.usuario && this.usuario.unco > 0;
  }

  isAvailableBody() {
    return !this.mensajeLoading && !this.mensajeError && this.agrupacion;
  }

  agruparPorSede(data: AdmisionAbiertaEntity[]) {

    this.totalAdmisiones = data.length;

    const grupos: AgrupacionSedeAdmisionAbiertaEntity[] = [];

    data.forEach((adm: AdmisionAbiertaEntity) => {
      const uncoSede = adm.uncoSede;
      const sedeIndex = grupos.findIndex((a: AgrupacionSedeAdmisionAbiertaEntity) => a.unco === uncoSede);
      if(sedeIndex === -1) {
        const grupoSede: AgrupacionSedeAdmisionAbiertaEntity = {
          unco : adm.uncoSede,
          sede : adm.sede,
          datos : [ adm ]
        };
        grupos.push(grupoSede);
      } else {
        grupos[sedeIndex].datos.push(adm);
      }
    });

    this.agrupacion = grupos;
  }

}
